import { render, staticRenderFns } from "./disabled.vue?vue&type=template&id=2e1b3566&scoped=true&"
import script from "./disabled.vue?vue&type=script&lang=js&"
export * from "./disabled.vue?vue&type=script&lang=js&"
import style0 from "./disabled.vue?vue&type=style&index=0&id=2e1b3566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b3566",
  null
  
)

export default component.exports